module.exports = __webpack_public_path__ + "static/media/card-labcar.6d8a2392.jpg";